module.exports = __webpack_public_path__ + "img/cs-icons-caption-filled.2a47bb79.svg";